import { TFunction } from "i18next"
import { SnackbarProps } from "src/providers/SnackbarProvider"
import { NoConnectionError, RequestError } from "src/models/errors"

/**
 * Show error on UI using snackbar element
 *  
 * @param error Error instance
 * @param snackbar reference to component props with snackbar 
 * @param t Translation package
 * @param onError [optional] callback function invoked if any previous type was not invoked. 
 */
export function snackbarErrorHandler(error: any, snackbar: SnackbarProps, t:TFunction, onError = () => {console.error(error)}):void {
  console.error(error)
  if(error instanceof RequestError) {
    snackbar.snackbarShowMessage(t(error.getI18nCode()), 'error'); return}
  if(error instanceof NoConnectionError) {
    snackbar.snackbarShowMessage(t(error.getI18nMsg()), 'error'); return}
  onError()
}